import styled from "styled-components"

const Close = styled.button`
  color: ${props => props.theme.colors.grey};
  font-size: 20px;
  position: absolute;
  right: 23px;
  top: 15px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 22px;
    right: 25px;
    top: 28px;
  }

  &:before {
    transition: color 0.3s;
  }

  .no-touchevents &:hover {
    &:before {
      color: ${props => props.theme.colors.primary};
    }
  }
`

const Title = styled.span`
  color: ${props => props.theme.colors.grey};
  display: block;
  font-size: 21px;
  font-weight: ${props => props.theme.title.w};
  width: 100%;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    color: ${props => props.theme.colors.primary};
    font-size: 14px;
  }
`

const List = styled.ul`
  margin: 10px -10px -10px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    display: flex;
    flex-wrap: wrap;
    margin: 30px -10px -10px;
  }
`

const Item = styled.li`
  padding: 10px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    width: calc(100% / 4);
  }

  a {
    font-size: 16px;
    transition: color 0.3s;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 18px;
    }

    .no-touchevents &:hover {
      color: ${props => props.theme.colors.primary};
    }
  }
`

const Wrapper = styled.div`
  background-color: #fff;
  backface-visibility: ${props => (props.open ? `visible` : `hidden`)};
  height: calc(${props => props.theme.units.vh}px * 100);
  left: 0;
  opacity: ${props => (props.open ? `1` : `0`)};
  overflow-y: auto;
  position: fixed;
  top: 0;
  transition-delay: ${props => (props.open ? `0s` : `.7s`)};
  transition-duration: 0.5s;
  transition-property: visibility, opacity, z-index;
  visibility: ${props => (props.open ? `visible` : `hidden`)};
  width: 100%;
  z-index: ${props => (props.open ? `10` : `-10`)};

  > div {
    display: flex;   
    height: 100%; 
    position: relative;

    @media only screen and (max-width: calc(${props => props.theme.mq.small} - 1px)) {
           flex-direction: column;
        }

    > div {
      padding-bottom: 50px;
      padding-top: 60px;
      width: 100%;

        @media only screen and (min-width: ${props => props.theme.mq.small}) {
          display: flex;
          flex-direction: column;
          margin: auto 0;
          padding-bottom: 50px;
          padding-top: 75px;
        }
    }
  }

  ${Close} {
    opacity: ${props => (props.open ? `1` : `0`)};
    transition-delay: ${props => (props.open ? `.5s` : `.1s`)};
    transition-duration: 0.5s;
    transition-property: opacity;
  }

    ${List}, ${Title} {
        opacity: ${props => (props.open ? `1` : `0`)};    
        transform: ${props => (props.open ? `translateY(0)` : `translateY(25px)`)};
            transition-delay: ${props => (props.open ? `.3s` : `.3s`)};
        transition-duration: 0.5s;
        transition-property: opacity, transform;

        @media only screen and (min-width: ${props => props.theme.mq.small}) {
            transform: ${props => (props.open ? `translateY(0)` : `translateY(50px)`)};
        }
    }
`

export const sSubcategories = {
  Wrapper,
  Close,
  Title,
  List,
  Item,
}
